import React from 'react';
import { useForm } from '@mantine/form';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import {
  getFinancialFormSetupValues,
  ProductFormComponentProps,
} from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { FormTitle } from 'src/financial/financial-data/financial-item/forms/common/FormTitle';
import { DynamicUiProviderWrapper } from 'src/financial/financial-data/financial-item/forms/common/DynamicUiProviderWrapper';
import { FinancialFormContainer } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormContainer';

type Props = {
  product: string;
  title: string;
  children?: React.ReactNode;
} & ProductFormComponentProps;

export function GenericFinancialItemFormWrapper(props: Props) {
  const { children, product, title } = props;
  const { isCreateMode, uiData, initialValues, onDeleteConfirm, feedInfo, onConnectAsset } =
    getFinancialFormSetupValues(product, props);

  const form = useForm<FormValuesType>({
    mode: 'uncontrolled',
    initialValues: initialValues,
  });

  const handleSave = async (values: FormValuesType) => {
    await props.onSave(values[product], uiData.ui.entitiesMetadata[product]);
  };

  return (
    <DynamicUiProviderWrapper
      form={form}
      uiData={uiData}
      onDeleteConfirm={onDeleteConfirm}
      isCreateMode={isCreateMode}
    >
      <form onSubmit={form.onSubmit(handleSave)} autoComplete={'off'}>
        <FinancialFormContainer
          title={<FormTitle title={title} />}
          feedInfo={feedInfo}
          onConnect={onConnectAsset}
        >
          {children}
        </FinancialFormContainer>
      </form>
    </DynamicUiProviderWrapper>
  );
}
